<script setup lang="ts">
import AppButton from "~/components/Common/Buttons/AppButton.vue";
import { useAttendanceReviewStore } from "~/store/attendance/attendance-review.store";
import { getCopilotErrorPresentation } from "~/utils/helpers/copilot/errors";
import type { ICopilotError } from "~/utils/interfaces/copilot-blocks-interfaces";

const props = defineProps<{ error: ICopilotError }>();
const store = useAttendanceReviewStore();
const { t } = useI18n();
const presentation = computed(() => getCopilotErrorPresentation(props.error));
</script>

<template>
  <div class="flex flex-col items-start gap-4" role="alert">
    <p class="body_regular whitespace-pre-wrap text-primary-color">{{ presentation.message }}</p>
    <AppButton
      v-if="error.resource"
      :label="t('ai_companion.attendance.open_session')"
      icon="arrow_right"
      reverse-icon
      @click="store.viewSession(error.resource.id)"
    />
  </div>
</template>
